export default __webpack_public_path__ + "static/media/sign-in-create-account.ed3474eb.png";